import Api from '@/services/api';
import qs from 'querystring';

export default {
  search(params, filters = [], hiddenFilter = '', page = 1, sortBy = 'date', sortDesc = false, fetchFacets = true) {

    return Api().post('/account-statements/search', qs.stringify({
      'search': JSON.stringify(params),
      'filters': JSON.stringify(filters),
      'hiddenFilter': hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc,
      'fetchFacets': fetchFacets
    }));
  },
  get(id) {
    return Api().get('/account-statement/' + id);
  },
  manage(creancierID, offset = 0) {
    return Api().post('/creditors/account-statements', qs.stringify({
      'offset': offset,
      'creancierID': creancierID
    }));
  },
  delete_releve(data) {
    return Api().delete('/account-statement/' + data.releve_id );
  },
  confirm(ids, offset = 0) {
    return Api().post('/account-statements/confirm', qs.stringify({'ids': JSON.stringify(ids), 'offset': offset}))
  }
}